// extracted by mini-css-extract-plugin
export default {"send_email_contact_button":"SendEmailComponent_send_email_contact_button__tYkF2"};